// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1ecNV","location":"Header_location__3x-A9"};